import { TFeaturesData } from './types';

export const featuresData: TFeaturesData = [
  {
    imgSrc: '/assets/images/feature1.png',
    text: ['”世界に一冊”の', 'オーダーメイド']
  }, {
    imgSrc: '/assets/images/feature2.png',
    text: ['全国送料：¥385', '（１冊の場合）']
  }, {
    imgSrc: '/assets/images/feature3.png',
    text: ['環境に配慮した素材を使用']
  }, {
    imgSrc: '/assets/images/feature4.png',
    text: ['出産やお誕生日の', 'プレゼントに']
  }
]
